import { Component, OnInit } from '@angular/core';
import { AccountInfoService } from '~app/core/modules/identity/services/account-info.service';
import { AuthorizationIdamStateService } from '~app/modules/authorization/services/authorization-idam-state.service';
import { environment } from '~env/environment';
import { IAccountInformation, IEmployee } from '~shared/models';

@Component({
  selector: 'app-employee-profile-box',
  templateUrl: './employee-profile-box.component.html',
  styleUrls: ['./employee-profile-box.component.scss']
})
export class EmployeeProfileBoxComponent implements OnInit {

  avatarIcon = `${environment.cdnBaseUrl()}/images/metrox/icon_avatar.svg`;
  authState$ = this.authIdamStateService.state$;
  employeeAccountDetails: IEmployee;
  customerAccountDetails: IAccountInformation;
  isOpen = false;
  accountType$ = this.accountInfoService.accountType$;

  constructor(
    private authIdamStateService: AuthorizationIdamStateService,
    private accountInfoService: AccountInfoService
  ) {
    this.accountInfoService.getEmployeeAccountInfo().subscribe((info: IEmployee) => {
      this.employeeAccountDetails = info;
    });
    this.accountInfoService.getAccountInfo().subscribe((info: IAccountInformation) => {
      this.customerAccountDetails = info;
    });
  }

  ngOnInit(): void {
  }

  handleProfileBoxClick(event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen
  }

  handleMenuClosed(closed: boolean) {
    this.isOpen = closed;
  }

}
